import { Song } from '@repo/types'

export const isSongWithAlbum = (song: Song): song is Song & { album: string } => {
  return song.album !== undefined
}
